import { useEffect } from "react"
import useIsSsr from "@/hooks/useIsSsr"

const useResizeObserver = (refToObserve, callbackFunction) => {
  const isSsr = useIsSsr()

  useEffect(() => {
    if (
      isSsr ||
      !refToObserve?.current ||
      typeof callbackFunction !== "function" ||
      typeof ResizeObserver === "undefined"
    ) {
      return
    }

    const resizeObserver = new ResizeObserver(entries => {
      callbackFunction(entries)
    })

    resizeObserver.observe(refToObserve.current)

    return () => {
      resizeObserver.disconnect()
    }
  }, [refToObserve, callbackFunction, isSsr])
}

export default useResizeObserver
